import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import {ScreenFormatContext} from "@mnjsplatform/data";
import i18next from "i18next";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";

export default (props) => {
    /*
        console.log(`ItemInject: props.viewMethod=${JSON.stringify(props.viewMethod)} rowKey=${JSON.stringify(props.rowKey)}`);
        console.log(`props=${JSON.stringify(props)}`);
    */
    return <ItemInjector key={props.viewMethod}
                         dataItem={{
                             controller: "YearBonus",
                             methodName: props.viewMethod,
                             withParamset: true,
                             fieldName: props.viewMethod + '_' + props.currentYear
                         }}><ConnectedYearBonusDetail {...props} /></ItemInjector>
};

class YearBonusDetail extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false
        };
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps) {
        if (this.props.viewMethod !== prevProps.viewMethod || this.props.currentYear !== prevProps.currentYear || this.props.rowKey.SalaryChangeIntId !== prevProps.rowKey.SalaryChangeIntId) {
            this.initialize();
        }
    }

    initialize = async () => {
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.dataItem.reset());
                await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
                    //newItem: true,
                    withParams: false, withStyle: false
                }));
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }

    refreshTable = async () => {
        try {
        } catch (e) {
            console.error(e);
        }
    }

    headerStyleProvider = () => {
        let cellStyle = {textAlign: 'center'};
        return cellStyle;
    }

    headerCellStyleProvider = () => {
        let cellStyle = {border: '1px solid #dee2e6'};
        return cellStyle;
    }

    cellStyleProvider = (dataItem, rowIndex, fieldInfo) => {
        let cellStyle = {border: '1px solid #dee2e6'};
        if (fieldInfo.DataType === 'System.Decimal') {
            return Object.assign(cellStyle, {textAlign: 'center'});
        }
        return cellStyle;
    }

    gridContentContainerStyleProvider = ({mobileMode}) => {
        if (!mobileMode) {
            //let height = window.innerHeight;
            let height = 600;
            return {
                minHeight: "150px", height: height + "px"
            };
        }
    }

    render() {
        return (<ScreenFormatContext.Consumer>
                {isDesktop => {
                    return (<PlaceholderWrapper placeholderId="10" canCollapse={false} showSplitterLine={false}>
                            {this.state.isDataReady ? <>
                                <GridView dataItem={this.props.dataItem} readOnly={true}
                                          fixHeader={true}
                                          contentContainerStyleProvider={this.gridContentContainerStyleProvider}
                                          headerStyleProvider={this.headerStyleProvider}
                                          headerCellStyleProvider={this.headerCellStyleProvider}
                                          cellStyleProvider={this.cellStyleProvider}
                                          useItemStyle={false}/>
                            </> : i18next.t('LoadingLabel')}
                        </PlaceholderWrapper>);
                }}
            </ScreenFormatContext.Consumer>);
    }
}

YearBonusDetail.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    rowKey: PropTypes.object,
    viewMethod: PropTypes.string,
    currentYear: PropTypes.number
}

YearBonusDetail.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.getItemState(state)
    }
}

const ConnectedYearBonusDetail = connect(mapStateToProps)(YearBonusDetail);